import { Field, useFormikContext } from "formik";
import { AnimatePresence, motion } from "framer-motion";
import { ChangeEvent, FC, useCallback } from "react";

import __ from "web/Layout/Translations";

import CloseIcon from "web/assets/icons/close.svg";
import Magnifier from "web/assets/icons/magnifier.svg";

import removeNonUTF8Chars from "web/utils/removeNonUTF8Chars";

import classes from "./searchField.scss";

interface ISearchAutocompleteSearchFieldProps {
  name: string;
  currentValue: string;
}

const SearchAutocompleteSearchField: FC<
  ISearchAutocompleteSearchFieldProps
> = ({ name, currentValue }) => {
  const { setFieldValue } = useFormikContext();
  const clearHandler = useCallback(() => {
    setFieldValue(name, "");
  }, [setFieldValue, name]);

  return (
    <div className={classes.root}>
      <button
        className={classes.submit}
        type="submit"
        data-t1="search_submit"
        aria-label={__("Wyszukaj")}
      >
        <Magnifier width={26} />
      </button>
      <Field
        className={classes.input}
        type="text"
        name={name}
        placeholder={__("Czego szukasz?")}
        autoComplete="off"
        data-t1="search_input"
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setFieldValue(name, removeNonUTF8Chars(e.target.value))
        }
        aria-label={__("Wpisz wyszukiwaną frazę")}
      />
      <AnimatePresence>
        {currentValue && (
          <motion.button
            key="search-clear"
            className={classes.clear}
            type="button"
            onClick={clearHandler}
            data-t1="search_clear"
            aria-label={__("Wyczyść wyszukiwaną frazę")}
            data-testid="search_clear"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <CloseIcon width={18} />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SearchAutocompleteSearchField;
